import styled from "@emotion/styled";
import { getGelTokens } from "@tal-gel/theming";

export const StyledProductContainer = styled.div`
  background-color: ${(props) => props.backgroundColor};
  padding: ${getGelTokens().global.sizeBaseX5}px; //20px

  &:before {
    transition-property: height;
    transition-duration: 350ms;
    content: "";
    position: absolute;
    top: 0;
    left: ${getGelTokens().global.sizeBaseX2}px; // 8px offset gutter of column
    right: ${getGelTokens().global.sizeBaseX2}px; // 8px offset gutter of column
    height: ${getGelTokens().global.sizeBaseX2}px;
    background: ${(props) => props.color};
    z-index: 5;
  }

  &:hover {
    cursor: pointer;

    &:before {
      height: 100%;
    }
  }
`;

export const StyledHeaderContainer = styled.div`
  height: 100%;
  min-height: ${(props) => props.minHeight}px;
  position: relative;
  z-index: 10;
`;

export const StyledFooterContainer = styled.div`
  position: relative;
  z-index: 10;
  padding-top: ${(props) => props.paddingTop}px;
`;

export const StyledIconContainer = styled.div`
  width: fit-content;
  height: fit-content;
  border-radius: ${getGelTokens().global.borderRadiusRounded};
  transition-property: border;
  transition-duration: 350ms;
  border: ${(props) =>
    props.hover
      ? `2px solid ${getGelTokens().global.themeColorBorderInverse}`
      : `2px solid transparent`};
`;

export const StyledTitleContainer = styled.div``;

export const StyledTitle = styled.p`
  font-size: ${getGelTokens().global.fontSizeHeadingXSmall}px;
  font-weight: ${getGelTokens().global.fontWeightBold};
  font-family: ${getGelTokens().global.fontFamilySans};
  letter-spacing: ${getGelTokens().global.fontLetterSpacingHeadings}px;
  color: ${(props) =>
    props.inverse
      ? getGelTokens().global.themeColorTextInverse
      : getGelTokens().global.themeColorTextDark};
`;

export const StyledPlusIcon = styled.div(
  {
    borderRadius: getGelTokens().global.borderRadiusRounded,
    borderWidth: 1,
    borderColor: getGelTokens().global.themeColorBorderDark,
    width: "fit-content",
    height: "100%",
    borderStyle: "solid",
    padding: getGelTokens().global.sizeBaseX2,
    transition: "all 0.3s ease-in-out",
  },
  (props) => ({
    transform: props.hover && "scale(1.1)",
  })
);
